export default __webpack_public_path__ + "static/media/salesforceIcon.eef85673.svg";